var scope_0 = require('/zeit/12501431/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/14d3474e2aa31261831e47e0ba557403.js').default;
var scope_1 = require('/zeit/12501431/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    